import React from 'react';
import { Button } from 'react-bootstrap';
import { FormTextBox } from '../components/FormTextBox';

export const ThemeDesigner = (props) => {
    const onClickButton = () => {
        window.open("https://fabricweb.z5.web.core.windows.net/pr-deploy-site/refs/heads/master/theming-designer/index.html", "_blank");
    };
    const textChanger = (ev, input) => {
        const name = ev.target.name;
        const value = ev.target.value;
        props.themeChanger(name, value);
    };
    return <div>
        <p>To create a theme press the Create Theme button, then create the theme and export the JSON back into the text box below</p>
        <FormTextBox formLabel={"Theme Name"} name={"name"} textChanger={textChanger}
            placeholder="Theme name" value={props.themeName} readOnly={false} />
        <FormTextBox formLabel={"Theme"} name={"themeJson"} textChanger={textChanger}
            placeholder="Copy and Paste the theme json here" value={props.themeJson} readOnly={false}
            as="textarea" rows={15}
        />
        <Button onClick={onClickButton}>Create Theme</Button>
    </div>;
};


// WEBPACK FOOTER //
// ./src/components/themeDesigner/ThemeDesigner.js